import React, { Fragment, useCallback, useRef, useState } from "react";
import { Modal, Toast } from "@shopify/polaris";
import { useMutation } from "@apollo/react-hooks";

import { handleError } from "../../../helper";
import { REFUND_ORDER_FACEBOOK } from "../../../graphql/mutations";
import useToggle from "../../../hooks/useToggle";

export const RefundOrderFacebook = ({
    open,
    value,
    onClose = () => {},
    refetch = () => {},
}) => {
    // Props
    const id = value.id;

    // State
    const [active, toggleActive] = useToggle(false);
    const [notify, setNotify] = useState({ msg: null, err: false });
    const timeoutRef = useRef(null);

    // Mutation
    const [refund, { loading }] = useMutation(REFUND_ORDER_FACEBOOK, {
        onError: (err) => {
            setNotify({ msg: handleError(err.toString()), err: true });
            onClose(false);
        },
        onCompleted: () => {
            setNotify({ msg: "Refund this order successfully.", err: false });
            onClose(false);

            timeoutRef.current && clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                refetch();
            }, 1600);
        },
    });

    // Handle action
    const handleSubmit = useCallback(() => {
        if (id != null) {
            toggleActive(true);
            setNotify({ msg: null, err: false });

            refund({
                variables: {
                    id,
                },
            });
        }
    }, [id, refund, toggleActive, setNotify]);

    // Markup
    const toastMarkup = active && notify.msg && (
        <Toast
            content={notify.msg}
            error={notify.err}
            duration={1500}
            onDismiss={toggleActive}
        />
    );

    return (
        <Fragment>
            {toastMarkup}
            <Modal
                title="Refund Order"
                open={open}
                onClose={onClose}
                sectioned
                secondaryActions={[{ content: "Cancel", onAction: onClose }]}
                primaryAction={{
                    content: "Submit",
                    onAction: handleSubmit,
                    loading: loading,
                }}
            >
                <p>Are you sure to refund this order?</p>
            </Modal>
        </Fragment>
    );
};
